import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'

import { EnrollmentDetailAPIResponse } from './enrollment-steps-service-types'
import { transformEnrollmentDetail } from './enrollment-steps-utils'

const getEnrollmentUrl = () => makeApiUrl('/enrollment/v2/enrollments')

export const createEnrollmentStepsService = (client = httpServiceClient) => ({
  async fetchEnrollmentStepsDetail(enrollmentId: string) {
    const pathUrl = `${getEnrollmentUrl()}/${enrollmentId}/steps`
    const response = await client<EnrollmentDetailAPIResponse>({
      method: 'get',
      url: pathUrl
    })

    return transformEnrollmentDetail(response.body.data as EnrollmentDetailAPIResponse)
  }
})

export const enrollmentStepsService = createEnrollmentStepsService()
